module.exports = __webpack_public_path__ + "images/speed-icon.d6c0148072fa821aca5151dc8c3457f8.png";